<app-header></app-header>

<div class="booking-photos container">
  <button class="button button--small button--white"
    [routerLink]="['/my-account']"
    >
    <i class="fa-solid fa-arrow-left"></i>
    {{'bookings.photos.back'|transloco}}
  </button>

  <div class="booking-photos__header">
    <h1>{{'bookings.photos.title'|transloco}}</h1>
  </div>

  <div class="booking-photos__banner">
    <div class="left">
      <div class="content">
        <h2>
          <i class="fa-solid fa-cloud-arrow-down"></i>
          {{'bookings.photos.banner.title'|transloco}}
        </h2>
        <p>{{'bookings.photos.banner.content'|transloco: {'days': 30} }}</p>
      </div>
    </div>

    @if (booking && booking.photos.length > 0) {
      <div class="booking-photos__download">
        <button
          class="button"
          [class.button--loading]="isDownloading"
          (click)="downloadPhotos()"
          [disabled]="isDownloading"
        >
          <i class="fa-solid fa-file-zipper"></i>
          {{ 'bookings.photos.downloadAll' | transloco }}
        </button>
      </div>
    }
  </div>

  @if (booking) {
    <div class="photos-list">
      @for (photo of booking.photos; track photo; let index = $index) {
        <div class="photo"
          (click)="openCarousel(index)"
        >
          <app-image
            [src]="photo.url"
            [alt]="'Photo ' + photo.id"
            preset="card"
            aspectRatio="1"
            [sizes]="'270px'"
            [width]="270"
            [height]="270"
          ></app-image>
          <p class="name">#{{booking.id}}_{{photo.id}}</p>
        </div>
      }
    </div>
  }

  @if (!booking) {
    <div class="photos-list">
      @for (_ of [0, 1, 2, 3]; track _) {
        <div class="photo"
          >
          <div class="skeleton-loading"></div>
        </div>
      }
    </div>
  }
</div>

@if (booking) {
  <app-carousel
    [photos]="booking.photos"
    [open]="isCarouselOpen"
    [index]="carouselIndex"
    (onClose)="closeCarousel()"
  ></app-carousel>
}
